import React from "react";
import { useTranslation } from "react-i18next";
import MiddlewareLayout from "src/components/middlewares/MiddlewareLayout";

interface NoSubscriptionMiddlewareProps {
	children?: any;
	tabs?: any;
}

const NoSubscriptionMiddleware = ({
	children,
	tabs,
}: NoSubscriptionMiddlewareProps) => {
	const { t } = useTranslation("middlewares", {
		keyPrefix: "no-subscription",
	});
	return (
		<MiddlewareLayout title="" {...{ tabs }} heading={t("title")}>
			{children}
			<div className="flex flex-col">
				<p className="max-w-md text-center">{t("description")}</p>
			</div>
		</MiddlewareLayout>
	);
};

export default NoSubscriptionMiddleware;
